import { flagEmojiFromIso } from '../../utils/countryFlag.js';

/**
 * Drapeau pays rendu via `flag-icons` (SVG embarqués) — fiable sur tous les OS,
 * y compris Windows/Chrome qui n'affichent pas les emojis drapeaux.
 * Repli : emoji drapeau, puis code ISO en texte.
 *
 * @param {{ country?: { code?: string } | null, code?: string, className?: string }} props
 */
function CountryFlag({ country, code, className = '' }) {
  const iso = (code || country?.code || '').toUpperCase();
  if (!iso || iso.length !== 2) {
    return null;
  }
  const title = country?.name || iso;
  return (
    <span
      className={`fi fi-${iso.toLowerCase()} country-flag ${className}`.trim()}
      role="img"
      aria-label={title}
      title={title}
      data-fallback={flagEmojiFromIso(iso) || iso}
    />
  );
}

export default CountryFlag;
